import { Box, Button, Divider, Grid, TextField, Typography } from '@mui/material'
import { MerChantModel } from '../../../models/merChantModel'
import SelectBranchComponent from '../components/SelectBranch'
import useAmountCouponController from '../controller/form/amountController'
import { CouponEnum } from '../../../enums/couponEnum'
import ConfirmDialog from '../../../components/ConfirmDialog'
import { useTranslation } from 'react-i18next'

interface Props {
    branchData: MerChantModel[]
    couponType: CouponEnum
    onClose: VoidFunction
    onFetchData: Function
}

const AmountComponentPage = ({ branchData, couponType, onClose, onFetchData }: Props) => {
    const { t } = useTranslation('global');
    const controller = useAmountCouponController({ branchData, couponType, onClose, onFetchData })

    return (
        <Box sx={{
            p: 3,
            boxShadow:
                '0px 0px 2px rgba(145, 158, 171, 0.2), 0px 12px 24px -4px rgba(145, 158, 171, 0.12)',
            borderRadius: '10px',
            maxWidth: 600,
            m: 2
        }}>
            <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                    <TextField inputRef={controller.couponName} fullWidth label={t('coupon_page.Coupon name')} InputLabelProps={{ shrink: true }} sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField inputRef={controller.couponCode} fullWidth label={t('coupon_page.Coupon Code')} InputLabelProps={{ shrink: true }} sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField inputRef={controller.limitUse} fullWidth label={t('coupon_page.Limit Use')} InputLabelProps={{ shrink: true }} sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField inputRef={controller.limitPerUser} fullWidth label={t('coupon_page.Usage')} InputLabelProps={{ shrink: true }} sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField inputRef={controller.startDate} fullWidth type='date' label={t('coupon_page.Start date')}  InputLabelProps={{ shrink: true }} sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField inputRef={controller.endDate} fullWidth type='date' label={t('coupon_page.End date')}  InputLabelProps={{ shrink: true }} sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField inputRef={controller.buyByPrice} fullWidth label={t('coupon_page.Buy Amount')} InputLabelProps={{ shrink: true }} sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    }} />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField inputRef={controller.discountPrice} fullWidth label={t('coupon_page.Discount Amount')} InputLabelProps={{ shrink: true }} sx={{
                        '& .MuiOutlinedInput-root': {
                            borderRadius: '8px',
                        },
                    }} />
                </Grid>
                <Grid item xs={12} sm={12}>
                    <SelectBranchComponent branchValue={controller.selectBranchDataValue} onSelectBranch={controller.handleSelectedBranch} branchData={branchData} role={controller.roleAdmin} />
                </Grid>
            </Grid>
            {controller.errorMessage && <Typography mt={1} color='error'>{controller.errorMessage}</Typography>} 
            <Divider sx={{ mt: 2, mb: 2 }} />
            <Box sx={{ display: 'flex', justifyContent: 'end' }}>
                <Button onClick={(e) => controller.handleSubmitForm()}  variant='contained' color='secondary' sx={{ textTransform: 'none', color: '#fff' }}>{t('coupon_page.Create coupon')}</Button>
            </Box>
            <ConfirmDialog
                open={controller.openConfirmForm}
                title={t('coupon_page.Do you want to Add this Coupon')}
                loading={controller.loadingButton}
                onCancel={controller.handleCloseConfirmFom}
                onConfirm={() => controller.handleCreatePromotion()}
            />
        </Box>
    )
}

export default AmountComponentPage